/**
 * @flow
 */
import React, { memo } from 'react';
import Modal from '@geneui/components/Modal';

import { positions } from 'config/settings/core-ui-strings';
// $FlowFixMe
import pdf from 'assets/pdf/Roulette_Unfairness_Detection_converted.pdf';
import './styles.scss';

type Props = {
  setIsOpen: Function,
  isOpen: boolean,
}

/**
 *
 * @param {boolean} isOpen - if true, the popup will be shown
 * @param {Function} setIsOpen - change visible status
 * @returns {Node} -
 * @constructor
 */

const HelpPopupContainer = ({ isOpen, setIsOpen }: Props) => (
  <Modal
    className="settings-popup-container"
    onCancel={() => setIsOpen(false)}
    position={positions.center}
    closeOnClickOutside
    title="LCRMT Help"
    visible={isOpen}
    footer={<></>}
    width="93%"
    withPortal
    closable
  >

    <embed
      src={pdf}
      style={{ width: '100%', height: '80vh' }}
    />
  </Modal>
);

HelpPopupContainer.displayName = 'HelpPopupContainer';

export default memo<Props>(HelpPopupContainer);
